import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-location-card',
    templateUrl: './location-card.component.html',
    styleUrls: ['./location-card.component.scss'],
    standalone: false
})
export class LocationCardComponent {
  @Input() location: any;
  @Input() title: string = '';
  @Input() cardType: 'from' | 'to' = 'from';

  constructor(private translate: TranslateService) {}

  getLocationTypeIcon(type: string): string {
    const iconMap: { [key: string]: string } = {
      'house': 'pi-home',
      'building': 'pi-building',
      'locality': 'pi-map-marker',
      'district': 'pi-map',
      'region': 'pi-globe',
      'country': 'pi-flag',
      'airport': 'pi-send',
      'station': 'pi-stop',
      'shop': 'pi-shopping-cart',
      'restaurant': 'pi-cutlery',
      'hotel': 'pi-moon',
      'hospital': 'pi-heart',
      'school': 'pi-book',
      'office': 'pi-briefcase',
      'industrial': 'pi-cog',
      'leisure': 'pi-star',
      'natural': 'pi-sun',
      'landuse': 'pi-th-large',
      'place': 'pi-map-marker',
      'administrative': 'pi-cog',
      'highway': 'pi-car',
      'railway': 'pi-forward',
      'waterway': 'pi-tint',
      'boundary': 'pi-stop'
    };
    
    return iconMap[type] || 'pi-map-marker';
  }

  getLocationTypeColor(type: string): string {
    const colorMap: { [key: string]: string } = {
      'house': 'text-blue-600',
      'building': 'text-indigo-600',
      'locality': 'text-purple-600',
      'district': 'text-pink-600',
      'region': 'text-red-600',
      'country': 'text-orange-600',
      'airport': 'text-yellow-600',
      'station': 'text-lime-600',
      'shop': 'text-green-600',
      'restaurant': 'text-teal-600',
      'hotel': 'text-cyan-600',
      'hospital': 'text-sky-600',
      'school': 'text-blue-500',
      'office': 'text-indigo-500',
      'industrial': 'text-gray-600',
      'leisure': 'text-emerald-600',
      'natural': 'text-green-500',
      'landuse': 'text-brown-600',
      'place': 'text-violet-600',
      'administrative': 'text-slate-600',
      'highway': 'text-gray-700',
      'railway': 'text-blue-700',
      'waterway': 'text-blue-400',
      'boundary': 'text-red-700'
    };
    
    return colorMap[type] || 'text-gray-500';
  }

  formatLocationDetails(location: any): string {
    if (!location) return '';
    
    const parts = [];
    
    if (location.district) parts.push(location.district);
    if (location.city) parts.push(location.city);
    if (location.state) parts.push(location.state);
    if (location.country) parts.push(location.country);
    
    return parts.join(', ');
  }

  getLocationTypeLabel(type: string): string {
    if (!type) {
      return this.translate.instant('common.location.types.place');
    }
    
    const translationKey = `common.location.types.${type}`;
    const translation = this.translate.instant(translationKey);
    
    // If translation is not found, return the original type
    return translation !== translationKey ? translation : type;
  }
}